// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.invoice-container {
    position: fixed; 
    top: 50px;
    right: 0; 
    padding: 0;
    margin: 0;
    background-color: #c2cfd7;
    border-radius: 12px;
    /* height: 100vh; */
    /* border-left: 2px solid gray; */
}

/* 
.summary-section {
    background-color: #f3f6fa; 
} */
.summary-title {
  font-weight: 600; 
  color: #4a4a4a; 
  font-size: 23px;
  text-align: center;
  margin-bottom: 40px;
  margin-top: 10px; 
}

.summary-item {
  font-size: 14px; 
  margin-bottom: 12px; 
  color: #555; 
}


.total {
  font-size: 20px; 
  font-weight: bold;
  color: #007bff;
  margin-top: 15px;
  text-align: right;
}
.summary-item span:first-child {
  font-weight: bold; /* Tăng độ đậm cho phần tiêu đề */
}

.total h4 {
}

.total h4:last-child {
  color: #ff5722; /* Màu cam nổi bật cho tổng giá */
}

.text-primary {
  color: #007bff !important;
}

.invoice-dates {
  font-size: 14px;
  color: #666;
  margin-top: 20px;
  text-align: left; /* Canh trái để dễ nhìn */
}

.checkout-button {
  background: linear-gradient(to right, #007bff, #0056b3); /* Hiệu ứng gradient */
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px; /* Góc bo mềm mại */
  width: calc(100% - 30px); /* Thu nhỏ nút bên trong container */
  margin: 0 auto; /* Căn giữa nút */
  display: block;
  color: #fff;
  border: 1px solid white;
  width: "100%";
  margin: 0px;
  padding: 5px;
  font-family:Georgia, 'Times New Roman', Times, serif;

}

.checkout-button:hover {
  background: linear-gradient(to right, #0056b3, #003d80); /* Hiệu ứng khi hover */
  color: #fff;
}
.invoice-container {
  margin-bottom: 16px;
}


@media (max-width: 480px) {
  .invoice-container {
    position: absolute; /* Đổi từ fixed sang absolute */
    bottom: 0; /* Đặt container nằm dưới cùng */
    left: 0; /* Căn lề trái */
    width: 100%; /* Chiều rộng full màn hình */
    top: auto; /* Loại bỏ vị trí top */
  }
}

/* Điều chỉnh cho màn hình di động lớn */
@media (min-width: 481px) and (max-width: 768px) {
  .invoice-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    top: auto;
  }
}

/* Điều chỉnh cho máy tính bảng */
@media (min-width: 768px) and (max-width: 1024px) {
  .invoice-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    top: auto;
  }
}

@media (min-width: 1024px) and (max-width: 1280px) {
  .invoice-container
  {
    width: 250px;

  }}
@media (min-width: 1281px) and (max-width: 1440px) {
  .invoice-container
  {
    width: 250px;

  }
  .summary-item {
    font-size: 12px; 
    margin-bottom: 12px; 
    color: #555; 
    
}
.summary-item h4 {
  font-size: 14px !important; /* Áp dụng font-size 12px */
  margin-bottom: 12px; 
  color: #555; 
}

.summary-title{
  font-size: 16px;
}
}
@media (min-width: 1441px) and (max-width: 1920px) {
  .invoice-container
  {
    width: 300px;

  }}
@media (min-width: 1921px) {
  .invoice-container
  {
    width: 300px;

  }}



  `, "",{"version":3,"sources":["webpack://./src/css/Invoice.css"],"names":[],"mappings":";;;AAGA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;;;GAGG;AACH;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA;AACA;;AAEA;EACE,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,uDAAuD,EAAE,sBAAsB;EAC/E,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAE,mBAAmB;EACvC,wBAAwB,EAAE,oCAAoC;EAC9D,cAAc,EAAE,iBAAiB;EACjC,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oDAAoD;;AAEtD;;AAEA;EACE,uDAAuD,EAAE,uBAAuB;EAChF,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;;AAGA;EACE;IACE,kBAAkB,EAAE,+BAA+B;IACnD,SAAS,EAAE,gCAAgC;IAC3C,OAAO,EAAE,gBAAgB;IACzB,WAAW,EAAE,6BAA6B;IAC1C,SAAS,EAAE,uBAAuB;EACpC;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;EACX;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,YAAY;;EAEd,CAAC;AACH;EACE;;IAEE,YAAY;;EAEd;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;;AAEf;AACA;EACE,0BAA0B,EAAE,2BAA2B;EACvD,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;AACA;EACE;;IAEE,YAAY;;EAEd,CAAC;AACH;EACE;;IAEE,YAAY;;EAEd,CAAC","sourcesContent":["\r\n\r\n\r\n.invoice-container {\r\n    position: fixed; \r\n    top: 50px;\r\n    right: 0; \r\n    padding: 0;\r\n    margin: 0;\r\n    background-color: #c2cfd7;\r\n    border-radius: 12px;\r\n    /* height: 100vh; */\r\n    /* border-left: 2px solid gray; */\r\n}\r\n\r\n/* \r\n.summary-section {\r\n    background-color: #f3f6fa; \r\n} */\r\n.summary-title {\r\n  font-weight: 600; \r\n  color: #4a4a4a; \r\n  font-size: 23px;\r\n  text-align: center;\r\n  margin-bottom: 40px;\r\n  margin-top: 10px; \r\n}\r\n\r\n.summary-item {\r\n  font-size: 14px; \r\n  margin-bottom: 12px; \r\n  color: #555; \r\n}\r\n\r\n\r\n.total {\r\n  font-size: 20px; \r\n  font-weight: bold;\r\n  color: #007bff;\r\n  margin-top: 15px;\r\n  text-align: right;\r\n}\r\n.summary-item span:first-child {\r\n  font-weight: bold; /* Tăng độ đậm cho phần tiêu đề */\r\n}\r\n\r\n.total h4 {\r\n}\r\n\r\n.total h4:last-child {\r\n  color: #ff5722; /* Màu cam nổi bật cho tổng giá */\r\n}\r\n\r\n.text-primary {\r\n  color: #007bff !important;\r\n}\r\n\r\n.invoice-dates {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin-top: 20px;\r\n  text-align: left; /* Canh trái để dễ nhìn */\r\n}\r\n\r\n.checkout-button {\r\n  background: linear-gradient(to right, #007bff, #0056b3); /* Hiệu ứng gradient */\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  border-radius: 4px; /* Góc bo mềm mại */\r\n  width: calc(100% - 30px); /* Thu nhỏ nút bên trong container */\r\n  margin: 0 auto; /* Căn giữa nút */\r\n  display: block;\r\n  color: #fff;\r\n  border: 1px solid white;\r\n  width: \"100%\";\r\n  margin: 0px;\r\n  padding: 5px;\r\n  font-family:Georgia, 'Times New Roman', Times, serif;\r\n\r\n}\r\n\r\n.checkout-button:hover {\r\n  background: linear-gradient(to right, #0056b3, #003d80); /* Hiệu ứng khi hover */\r\n  color: #fff;\r\n}\r\n.invoice-container {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n\r\n@media (max-width: 480px) {\r\n  .invoice-container {\r\n    position: absolute; /* Đổi từ fixed sang absolute */\r\n    bottom: 0; /* Đặt container nằm dưới cùng */\r\n    left: 0; /* Căn lề trái */\r\n    width: 100%; /* Chiều rộng full màn hình */\r\n    top: auto; /* Loại bỏ vị trí top */\r\n  }\r\n}\r\n\r\n/* Điều chỉnh cho màn hình di động lớn */\r\n@media (min-width: 481px) and (max-width: 768px) {\r\n  .invoice-container {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    top: auto;\r\n  }\r\n}\r\n\r\n/* Điều chỉnh cho máy tính bảng */\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .invoice-container {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    top: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) and (max-width: 1280px) {\r\n  .invoice-container\r\n  {\r\n    width: 250px;\r\n\r\n  }}\r\n@media (min-width: 1281px) and (max-width: 1440px) {\r\n  .invoice-container\r\n  {\r\n    width: 250px;\r\n\r\n  }\r\n  .summary-item {\r\n    font-size: 12px; \r\n    margin-bottom: 12px; \r\n    color: #555; \r\n    \r\n}\r\n.summary-item h4 {\r\n  font-size: 14px !important; /* Áp dụng font-size 12px */\r\n  margin-bottom: 12px; \r\n  color: #555; \r\n}\r\n\r\n.summary-title{\r\n  font-size: 16px;\r\n}\r\n}\r\n@media (min-width: 1441px) and (max-width: 1920px) {\r\n  .invoice-container\r\n  {\r\n    width: 300px;\r\n\r\n  }}\r\n@media (min-width: 1921px) {\r\n  .invoice-container\r\n  {\r\n    width: 300px;\r\n\r\n  }}\r\n\r\n\r\n\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
